import { MAP_TYPES } from '@deck.gl/carto';
 
const SYSTEMICRAMP_SOURCE_ID = 'systemicRampSource';
 
const source = {
  id: SYSTEMICRAMP_SOURCE_ID,
  type: MAP_TYPES.QUERY,
  connection: 'cartointegration',
  data: 'systemic_ramp_source',
};
 
export default source;